import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, Weekday } from '../../../../../services/api/api';
import { ErrorService } from '../../../../../services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../../../../services/util.service';
import { SbLocalDateTime } from '../../../../../services/api/api-date-time';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-airtime-reporting-header',
  templateUrl: './airtime-header.component.html',
  styleUrls: ['./airtime-header.component.scss'],
  standalone: false,
})
export class AirtimeHeaderComponent implements OnInit {
  broadcastingRate: number;
  playerCount: number;
  from: SbLocalDateTime;
  till: SbLocalDateTime;

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public translate: TranslateService,
    public util: UtilService,
    public destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.from = new SbLocalDateTime(DateTime.local().startOf('day').minus({ days: 2 }));
    this.till = new SbLocalDateTime(DateTime.local().startOf('day').minus({ days: 1 }));
    this.api
      .ss_nm_Reporting_airtimeQuota({
        productive: true,
        interval: 86400,
        weekday: [Weekday.MONDAY, Weekday.TUESDAY, Weekday.WEDNESDAY, Weekday.THURSDAY, Weekday.FRIDAY, Weekday.SATURDAY],
        hour: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        from: this.from,
        till: this.till,
      })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: data => {
          const dataFrame = data.buckets[0].frames[0].data;
          this.broadcastingRate = Math.round(dataFrame.quota * 100);
          this.playerCount = Math.round(dataFrame.devices);
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
